import React from 'react'
import utils from './utils'
import { images } from '../../../../services/assets.services'

function getLevelLayout(width, height, settings, quantities, answer, answerNumber = 1) {

    let gameContainerWidth = width
    let gameContainerHeight = height
    let scale = 0
    let gridBgWidth = 377
    let gridBgHeight = 210
    let lineWidth = 377
    let lineHeight = 20
    let valueBgWidth = 43
    let valueBgHeight = 33
    let axisLineWidth = 12
    let axisLineHeight = 34
    let axisSideMargin = 12

    if (gridBgWidth / gridBgHeight > gameContainerWidth / gameContainerHeight) {
        scale = gameContainerWidth / gridBgWidth
    } else {
        scale = gameContainerHeight / gridBgHeight
    }

    const isUp = quantities.value_1 < quantities.answer ? true : false
    const firstValue = quantities.value_1
    const secondValue = quantities.answer
    const type = settings.type
    const countDirection = settings.count_direction || 'right'

    const axisScale = +settings.axis_scale || 1
    const labelsScale = +settings.labels_scale || 1
    const stepSize = +settings.step_size || 1
    const axisStart = settings.axis_start_value || settings.axis_start_value === 0 ?
        settings.axis_start_value
        : (!isUp ? secondValue : firstValue)
    const axisEnd = settings.axis_end_value || settings.axis_end_value === 0 ?
        settings.axis_end_value
        : (!isUp ? secondValue : firstValue)
    const axisDivWidth = (gridBgWidth - axisSideMargin * 2 - axisLineWidth) / (axisEnd - axisStart)

    let maxArcHeight = 0

    let axisValues = []
    let curves = []

    for (let i = 0; i <= (axisEnd - axisStart); i += axisScale) {
        let axisValue = 0
        let textColour = '#fff'
        let forceShowLabel = false
        let showLabelOnTop = false
        let showLabel = i === 0 ||
            i === (axisEnd - axisStart) ||
            (i / axisScale) % labelsScale === 0 ? true : false
        if (countDirection === 'right') {
            axisValue = +axisStart + i
        } else {
            axisValue = +axisEnd - i
        }
        if (type === 'missing') {
            if (+axisValue === +quantities.answer) {
                axisValue = answer
                textColour = 'red'
                forceShowLabel = true
                showLabelOnTop = showLabel ? false : true
            }

        } else {
            let value = axisValue
            if (isUp) {
                if ((firstValue - value) % stepSize === 0 && value > +firstValue + answerNumber * stepSize && value <= secondValue) {
                    axisValue = '?'
                }
                if (value === +firstValue + answerNumber * stepSize) {
                    axisValue = answer
                    textColour = 'red'
                }

            } else {
                if ((secondValue - value) % stepSize === 0 && value >= secondValue && value < +firstValue - answerNumber * stepSize) {
                    axisValue = '?'
                }
                if (value === +firstValue - answerNumber * stepSize) {
                    axisValue = answer
                    textColour = 'red'
                }

            }
        }

        axisValues.push(

            <g key={i} transform={`translate(${axisSideMargin + i * axisDivWidth}, ${gridBgHeight - 20})`}>
                <image
                    width={axisLineWidth}
                    height={axisLineHeight}
                    xlinkHref={images.svg['number-line-axis']}

                />
                {(showLabel || forceShowLabel) && <text
                    fill={textColour}
                    fontSize={12}
                    fontWeight="regular"
                    dominantBaseline="middle"
                    x={6}
                    y={axisLineHeight + 10}
                    textAnchor="middle"
                >{axisValue}</text>}
            </g>
        )
    }
    if (type === 'count') {
        let start = isUp ? firstValue : secondValue
        let end = !isUp ? firstValue : secondValue
        for (let i = start; i < end; i += stepSize) {

            let arcStart = axisSideMargin + axisLineWidth / 2 + (countDirection === 'right' ? (i - axisStart) : axisEnd - i - stepSize) * axisDivWidth
            let arcLength = (stepSize) * axisDivWidth
            let arcRadius = (arcLength) / 1.8
            let centerToChordLenght = Math.sqrt(Math.pow(arcRadius, 2) - Math.pow(arcLength / 2, 2))
            maxArcHeight = arcRadius - centerToChordLenght + 40

            let isArrowShifted = isUp && countDirection === 'left' || !isUp && countDirection === 'right'
                ? false : true

            curves.push(
                <g key={i}>
                    <path
                        d={`M${arcStart} 185 a ${arcRadius} ${arcRadius} 0 0 1 ${arcLength} 0`}
                        stroke="#000"
                        strokeOpacity="0.1"
                        strokeWidth="4.01490021"
                        fill="none"
                        strokeDasharray="6.0312, 8.0415"
                        strokeLinejoin="round"
                        strokeLinecap="round"
                    />
                    <path
                        d={`M${arcStart} 180 a ${arcRadius} ${arcRadius} 0 0 1 ${arcLength} 0`}
                        stroke={isUp ? "#95c11f" : "#E30613"}
                        strokeWidth="4.01490021"
                        fill="none"
                        strokeDasharray="6.0312, 8.0415"
                        strokeLinejoin="round"
                        strokeLinecap="round"
                    />
                    {utils.getArrowLayout((isArrowShifted ? arcStart + arcLength : arcStart), 185, 40, 4.01490021, (isUp ? "#95c11f" : "#E30613"))}

                     <g transform={`translate(${arcStart + arcLength / 2 - valueBgWidth / 2}, ${180 + centerToChordLenght - arcRadius - valueBgHeight * 1.2})`}>
                        <image
                            width={valueBgWidth}
                            height={valueBgHeight}
                            xlinkHref={isUp ?images.svg['number-line-bg-green'] : images.svg['number-line-bg-red']}

                        />
                        <text
                            fill="#fff"
                            fontSize={12}
                            fontWeight="regular"
                            dominantBaseline="middle"
                            x={valueBgWidth / 2}
                            y={15}
                            textAnchor="middle"
                        >{(isUp ? '+' : '-') + stepSize}</text>
                    </g>
                </g>
            )
        }
    }
    return (
        <svg
            height={gameContainerHeight}
            width={gameContainerWidth}

        >
            <g transform={`translate(${(gameContainerWidth - gridBgWidth * scale) / 2}, ${(gameContainerHeight - gridBgHeight * scale - (gridBgHeight - maxArcHeight) * scale) / 2}), scale(${scale})`}>
                {axisValues}
                <image
                    width={lineWidth}
                    height={lineHeight}
                    xlinkHref={images.svg['number-line']}
                    transform={`translate(${0}, ${gridBgHeight - 13})`}
                />
                {curves}

            </g>
        </svg>
    )
}

export default {
    getLevelLayout,
}


// WEBPACK FOOTER //
// ./src/components/game/levels/utils/numberTracks.utils.js